import React from "react";
import { Button, Icon, Toast } from "antd-mobile";

import wx from "wx";

class Dame extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
        };
    }
    componentDidMount() {
        window.href = this.href;
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }

            this.setState(
                {
                    urlOps: ops,
                },
                () => {}
            );
        }
    }
    render() {
        return (
            <div className="DameBox">
                url: {window.location.href}
                <br/>
                supplierBranchCode: {this.state.urlOps.supplierBranchCode}
                <Button
                    onClick={() => {
                        wx.miniProgram.redirectTo({
                            url: `../maintenance-reserve/maintenance-reserve?fromScanningPage=true&supplierBranchCode=${this.state.urlOps.supplierBranchCode}`,
                        });
                    }}
                >
                    跳转
                </Button>
            </div>
        );
    }
}

export default Dame;



// WEBPACK FOOTER //
// ./src/demo/index.js